import { useMemo } from 'preact/hooks';

import { useJWBreakpoint } from './useJWBreakpoint';

export type Viewport = 'mobile' | 'tablet' | 'desktop';

export const getViewport = (breakpoint: jwplayer.Breakpoint): Viewport => {
  switch (breakpoint) {
    case -1:
    case 0:
    case 1:
    case 2:
    case 3:
      return 'mobile';
    case 4:
    case 5:
    case 6:
      return 'tablet';
    default:
      return 'desktop';
  }
};

const getSize = (
  breakpoint: jwplayer.Breakpoint,
  viewport: Viewport
): 'xs' | 's' | 'm' | 'l' => {
  if (breakpoint === -1) {
    return 'xs';
  }

  if (viewport === 'mobile') {
    return 's';
  }

  if (viewport === 'tablet') {
    return 'm';
  }

  return 'l';
};

export const useViewportType = () => {
  const { breakpoint } = useJWBreakpoint();

  const viewport = useMemo(() => getViewport(breakpoint), [breakpoint]);

  return {
    viewport,
    isMobile: viewport === 'mobile',
    isTablet: viewport === 'tablet',
    isDesktop: viewport === 'desktop',
    size: getSize(breakpoint, viewport),
  };
};
